import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import './Registro_viewer.css';

const Registro_viewer = () => {
  const [formData, setFormData] = useState({
    numeroUsuario: '',
    password: '',
    confirmPassword: '',
    email: '',
    confirmEmail: ''
  });

  const [validations, setValidations] = useState({
    minLength: false,
    hasUppercase: false,
    hasNumber: false,
    hasSymbol: false
  });

  const [errors, setErrors] = useState({});
  const [mensaje, setMensaje] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const navigate = useNavigate();

  // Validar requisitos de contrase�a
  const validatePassword = (password) => {
    const validations = {
      minLength: password.length >= 12,
      hasUppercase: (password.match(/[A-Z]/g) || []).length >= 2,
      hasNumber: (password.match(/[0-9]/g) || []).length >= 2,
      hasSymbol: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    };
    setValidations(validations);
    return validations;
  };

  // Manejar cambios en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Validar n�mero de usuario (solo n�meros, m�ximo 6 d�gitos)
    if (name === 'numeroUsuario') {
      const numValue = value.replace(/\D/g, '').slice(0, 6);
      setFormData({ ...formData, [name]: numValue });
      return;
    }

    setFormData({ ...formData, [name]: value });

    // Validar contrase�a en tiempo real
    if (name === 'password') {
      validatePassword(value);
    }

    // Limpiar errores al escribir
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  // Validar formulario
  const validateForm = () => {
    const newErrors = {};

    // Validar n�mero de usuario
    if (!formData.numeroUsuario) {
      newErrors.numeroUsuario = 'El numero de usuario es requerido';
    } else if (parseInt(formData.numeroUsuario) < 1 || parseInt(formData.numeroUsuario) > 999999) {
      newErrors.numeroUsuario = 'El numero debe estar entre 1 y 999,999';
    }

    // Validar contrase�a
    const passValidations = validatePassword(formData.password);
    if (!formData.password) {
      newErrors.password = 'La contraseña es requerida';
    } else if (!Object.values(passValidations).every(v => v)) {
      newErrors.password = 'La contraseña no cumple con todos los requisitos';
    }

    // Validar confirmaci�n de contrase�a
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Debe confirmar la contraseña';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Las contraseñas no coinciden';
    }

    // Validar email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = 'El email es requerido';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'El email no es valido';
    }

    // Validar confirmaci�n de email
    if (!formData.confirmEmail) {
      newErrors.confirmEmail = 'Debe confirmar el email';
    } else if (formData.email !== formData.confirmEmail) {
      newErrors.confirmEmail = 'Los emails no coinciden';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');

if (!validateForm()) {
      setMensaje('Por favor corrige los errores del formulario');
      return;
    }

    if (!captchaToken) {
      setMensaje('Por favor confirma que no eres un robot.');
      return;
    }

  try {
    const response = await fetch(`${process.env.REACT_APP_REGISTRO_VIEWER_URL}/Envioregistro.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
body: JSON.stringify({
          numero_usuario: formData.numeroUsuario,
          password: formData.password,
          email: formData.email,
          captcha_token: captchaToken
        })
    });

      const data = await response.json();

      if (data.success) {
        setMensaje('? Registro exitoso. Bienvenido a Ulalaaa!');
        // Limpiar formulario
        setFormData({
          numeroUsuario: '',
          password: '',
          confirmPassword: '',
          email: '',
          confirmEmail: ''
        });
        setValidations({
          minLength: false,
          hasUppercase: false,
          hasNumber: false,
          hasSymbol: false
        });
        setCaptchaToken(null);
        if (captchaRef.current) captchaRef.current.reset();
        // Redirigir a la página de acceso después de 2 segundos
        setTimeout(() => {
          navigate('/acceso_viewer');
        }, 8000);
      } else {
        setMensaje('? Error: ' + data.message);
      }
    } catch (error) {
      console.error('Error:', error);
      setMensaje('? Error de conexion con el servidor');
    }
  };

  return (
    <>
      <div className="registro-viewer-container">
      <div className="registro-viewer-card">
        <h1 className="registro-title">Registrate</h1>
        <p className="registro-subtitle">Bienvenido a Ulalaaa - Ahora podras valorar a tu scort.</p>

        <form onSubmit={handleSubmit} className="registro-form">
          
          {/* Nombre de Usuario */}
          <div className="form-group">
            <label className="form-label">
              Numero de usuario <span className="required">:</span>
            </label>
            <div className="usuario-input-container">
              <span className="usuario-prefix">Anonimo [ </span>
              <input
                type="text"
                name="numeroUsuario"
                value={formData.numeroUsuario}
                onChange={handleChange}
                className={`form-input numero-input ${errors.numeroUsuario ? 'input-error' : ''}`}
                placeholder=""
                maxLength="6"
              />
              <span className="usuario-suffix"> ]</span>
            </div>
            <small className="input-helper">Maximo 6 caracteres, del 1 al 999,999</small>
            {errors.numeroUsuario && <span className="error-message">{errors.numeroUsuario}</span>}
          </div>

          {/* Password */}
          <div className="form-group">
            <label className="form-label">
              Password <span className="required">:</span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={`form-input ${errors.password ? 'input-error' : ''}`}
            />
            
            {/* Indicador de requisitos de contrase�a */}
            <div className="password-requirements">
              <small className={validations.minLength ? 'requirement-met' : 'requirement-unmet'}>
                {validations.minLength ? '?' : '?'} Minimo 12 caracteres
              </small>
              <small className={validations.hasUppercase ? 'requirement-met' : 'requirement-unmet'}>
                {validations.hasUppercase ? '?' : '?'} Minimo 2 letras mayusculas
              </small>
              <small className={validations.hasNumber ? 'requirement-met' : 'requirement-unmet'}>
                {validations.hasNumber ? '?' : '?'} Minimo 2 numeros
              </small>
              <small className={validations.hasSymbol ? 'requirement-met' : 'requirement-unmet'}>
                {validations.hasSymbol ? '?' : '?'} Al menos 1 simbolo (!@#$%^&*...)
              </small>
            </div>
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          {/* Confirma Password */}
          <div className="form-group">
            <label className="form-label">
              Confirma Password <span className="required">:</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className={`form-input ${errors.confirmPassword ? 'input-error' : ''}`}
            />
            {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
          </div>

          {/* Email */}
          <div className="form-group">
            <label className="form-label">
              Email <span className="required">:</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`form-input ${errors.email ? 'input-error' : ''}`}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          {/* Confirma Email */}
          <div className="form-group">
            <label className="form-label">
              Confirma Email <span className="required">:</span>
            </label>
            <input
              type="email"
              name="confirmEmail"
              value={formData.confirmEmail}
              onChange={handleChange}
              className={`form-input ${errors.confirmEmail ? 'input-error' : ''}`}
            />
            {errors.confirmEmail && <span className="error-message">{errors.confirmEmail}</span>}
          </div>

          {/* Bot�n Enviar */}
<div className="button-container">
            <div style={{display:'flex', justifyContent:'center', marginBottom:'16px'}}>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setCaptchaToken(token)}
                onExpired={() => setCaptchaToken(null)}
                theme="dark"
                hl="es"
              />
            </div>
            <button type="submit" className="btn-enviar">
              Enviar
            </button>
          </div>

          {/* Mensaje de respuesta */}
          {mensaje && mensaje.includes('Registro exitoso') && (
            <div className="mensaje-overlay">
              <div className="mensaje-overlay-content">
                <h1 className="mensaje-overlay-titulo">BIENVENIDO A ULALAAA</h1>
                <h2 className="mensaje-overlay-subtitulo">REGISTRO EXITOSO</h2>
                <p className="mensaje-overlay-texto">
                  {'Revisa tu correo y haz clic en el enlace de verificaci\u00F3n para activar tu cuenta.'}<br/><br/>
                  <strong style={{color:'#00CED1'}}>{'No podr\u00E1s iniciar sesi\u00F3n hasta verificar tu email.'}</strong>
                </p>
              </div>
            </div>
          )}
          
{/* Mensaje de error */}
          {mensaje && !mensaje.includes('Registro exitoso') && (
            <div className="mensaje mensaje-error" style={{color:'#ffffff'}}>
              {mensaje}
            </div>
          )}
        </form>
      </div>
</div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default Registro_viewer;